export { default } from './ChattelProperty';
